import React, {useState} from 'react';
import {Button, Col, Modal, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEraser, faPlus} from "@fortawesome/free-solid-svg-icons";
import NewFreigabeAuftraggeberModalTable from "./NewFreigabeAuftraggeberModalTable";

function NewFreigabeAuftraggeber(props) {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            <Row>

                <Col sm={5}
                >
                    <label className="handwai-text-label-main add-bottom-0-margin">{"Freigabe"}</label>
                </Col>
                {!props.originState &&
                    <Col sm={1}
                         style={{paddingLeft: 0,textAlign:"Right"}}
                    >
                        <Button
                            className='handwai-btn-create'
                            onClick={handleShow}
                            disabled={props.disable}
                        >
                            <FontAwesomeIcon icon={faPlus}/></Button>
                    </Col>}
            </Row>
            <Modal show={show} onHide={handleClose}
                   aria-labelledby="contained-modal-title-vcenter"
                   centered>
                <Modal.Header closeButton>
                    <Modal.Title>Auftraggeber Information</Modal.Title>
                </Modal.Header>
                <Modal.Body className="handwai-dark">
                    <NewFreigabeAuftraggeberModalTable
                        projectID={props.projectID}
                        auftraggeberReportData={props.auftraggeberReportData}
                        setAuftraggeberReportData={props.setAuftraggeberReportData}
                        projectIDData={props.projectIDData}
                        setIsChange={props.setIsChange}
                        setShow={setShow}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button size='lg' block className='handwai-btn-create'
                            onClick={handleClose}> <FontAwesomeIcon
                        icon={faEraser}/> &emsp;
                        Schließen
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default NewFreigabeAuftraggeber;
